export function getDropReportToDate(drop) {
    const { expirationDate } = drop;
    if (!expirationDate) {
        return new Date().toISOString();
    }
    const isExpired = new Date(expirationDate) < new Date();
    return isExpired ? expirationDate : new Date().toISOString();
}
